import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { deleteIcon } from '../../../../assets/icons';
import Button from '../../../elements/button';
import Card from '../../../elements/card';

// const AddInstruction = ({ setAddInstruction, loading }) => {
//   return (
//     <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40 ">
//       <Card className="w-[800px] h-auto md:h-[750px]">
//         <div>
//           <div className="flex items-center justify-between">
//             <div></div>
//             <button onClick={() => setAddInstruction(false)}>
//               <Image src={deleteIcon} alt="Delete | Stakecut" />
//             </button>
//           </div>
//         </div>
//         <section>
//           <h3 className="font-semibold text-[20px] my-4">
//             Kindly Note the following Instruction before listing your product.
//           </h3>
//           <div>
//             <ul className="list-decimal">
//               <li className="mb-4">
//                 1. Your Product must have a Sales Page for your product. Else
//                 you can request the stakecut team to help you write your sales
//                 copy & setup your sales page for your product by sending an
//                 email to{' '}
//                 <Link href="mailto:hello@stakecut.com" passHref>
//                   <span className="text-secondary"> hello@stakecut.com</span>
//                 </Link>{' '}
//                 or you can go ahead to get it done if you want to handle it.
//               </li>

//               <li className="mb-4">
//                 2. Professionally designed sales page with excellent sales copy.
//               </li>

//               <li className="mb-4">3. Valuable educational video contents.</li>

//               <li className="mb-4">
//                 4. Contents must be original. Created and owned by the vendor.
//                 Courses containing contents of other creators would be rejected.
//               </li>

//               <li className="mb-4">5. Video quality in HD - 1920p x 1080p.</li>

//               <li className="mb-4">
//                 6. Video aspect ratio must be in 16:9 dimension, with exception
//                 for cases of mobile app courses.
//               </li>

//               <li className="mb-4">
//                 7. Audio must be clear, loud, synced with video and have no
//                 distracting background noise.
//               </li>

//               <li className="mb-4">
//                 8. Course must be hosted and delivered via an LMS or Web Page
//                 only. Course contents must be pre-recorded and not be live
//                 sessions.
//               </li>

//               <li className="mb-4">
//                 9. At least 30 minutes of video and at least 5 separate lessons.
//               </li>

//               <li className="mb-4">
//                 10. Have JV promotional materials for Affiliates.
//               </li>

//               <li className="mb-4">
//                 11. Course must have a sales page, thank you page and JV page
//               </li>

//               <li className="mb-4">
//                 12. You can watch this video to see how to list your product and
//                 install your pixel:{' '}
//                 <Link href={'https://youtu.be/4Rsr-IYqc2o'} passHref>
//                   <a
//                     className="text-secondary underline"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     https://youtu.be/4Rsr-IYqc2o
//                   </a>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//           <div className="mt-4">
//             <Button
//               type="submit"
//               label="Continue"
//               className="bg-primary lg:w-64 py-5 w-full text-light"
//               onClick={() => setAddInstruction(false)}
//             />
//           </div>
//         </section>
//       </Card>
//     </section>
//   );
// };

// export default AddInstruction;

const AddInstruction = ({ setAddInstruction, loading, onContinue }) => {
  return (
    <section className="h-full lg:w-screen w-full z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      <div className='relative lg:mx-10  mx-3  lg:w-[1080px] lg:h-[800px] h-full pt-10'>

        <div className="flex items-center justify-between  lg:absolute right-[0%] top-[0%] ">
          <div></div>
          <div className="">
            <button onClick={() => setAddInstruction(false)}>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_7374_19071)">
                  <path
                    d="M24.3167 13.332L20 17.6487L15.6834 13.332L13.3334 15.682L17.65 19.9987L13.3334 24.3154L15.6834 26.6654L20 22.3487L24.3167 26.6654L26.6667 24.3154L22.35 19.9987L26.6667 15.682L24.3167 13.332ZM20 3.33203C10.7834 3.33203 3.33337 10.782 3.33337 19.9987C3.33337 29.2154 10.7834 36.6654 20 36.6654C29.2167 36.6654 36.6667 29.2154 36.6667 19.9987C36.6667 10.782 29.2167 3.33203 20 3.33203ZM20 33.332C12.65 33.332 6.66671 27.3487 6.66671 19.9987C6.66671 12.6487 12.65 6.66536 20 6.66536C27.35 6.66536 33.3334 12.6487 33.3334 19.9987C33.3334 27.3487 27.35 33.332 20 33.332Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7374_19071">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
      <Card className="lg:w-[950px]  relative rounded-[30px]">
        <section className="lg:px-10 pt-3 pb-3 px-2">
          <h3 className="font-[600] text-[#205363] text-[18px] lg:text-[24px] leading-[26.4px]  my-4">
            Kindly Note the following Instruction before listing your product.
          </h3>
          <div>
            <ul className="list-disc text-[#828282]" style={{listStyle:"inside"}}>
              <li className="mb-4 list-disc">
               Your Product must have a Sales Page for your product. Else
                you can request the stakecut team to help you write your sales
                copy & setup your sales page for your product by sending an
                email to{' '}
                <Link href="mailto:hello@stakecut.com" passHref>
                  <span className="text-secondary"> hello@stakecut.com</span>
                </Link>{' '}
                or you can go ahead to get it done if you want to handle it.
              </li>
              <li className="mb-4">
                 Professionally designed sales page with excellent sales copy.
              </li>
              <li className="mb-4"> Valuable educational video contents.</li>
              <li className="mb-4">
                 Contents must be original. Created and owned by the vendor.
                Courses containing contents of other creators would be rejected.
              </li>
              <li className="mb-4"> Video quality in HD - 1920p x 1080p.</li>
              <li className="mb-4">
                 Video aspect ratio must be in 16:9 dimension, with exception
                for cases of mobile app courses.
              </li>
              <li className="mb-4">
                 Audio must be clear, loud, synced with video and have no
                distracting background noise.
              </li>
              <li className="mb-4">
                 Course must be hosted and delivered via an LMS or Web Page
                only. Course contents must be pre-recorded and not be live
                sessions.
              </li>
              <li className="mb-4">
                 At least 30 minutes of video and at least 5 separate lessons.
              </li>
              <li className="mb-4">
               Have JV promotional materials for Affiliates.
              </li>
              <li className="mb-4">
               Course must have a sales page, thank you page and JV page
              </li>
              <li className="mb-4">
                 You can watch this video to see how to list your product and
                install your pixel:{' '}
                <Link href={'https://youtu.be/4Rsr-IYqc2o'} passHref>
                  <a
                    className="text-secondary underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://youtu.be/4Rsr-IYqc2o
                  </a>
                </Link>
              </li>
            </ul>
          </div>
          <div className="mt-4">
            <Button
              type="submit"
              label="Continue"
              className="bg-primary w-full py-5  text-light"
              onClick={onContinue} // Call the function to proceed to the form
            />
          </div>
        </section>
      </Card>
      </div>
    </section>
  );
};

export default AddInstruction;
